import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.main.projects');
import { OnInit, ChangeDetectorRef as CDR, Input, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

@Component({
    selector: 'wiz-component-main-projects',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.main.projects/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class ComponentMainProjectsComponent implements OnInit {
    @Input() selectedProjects: any[] = [];
    @Output() onRemoved = new EventEmitter<any[]>();
    @Output() onGoTo = new EventEmitter<any>();

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() { }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '';
        return dateStr.split(' ')[0].split('T')[0];
    }

    public async remove(project: any) {
        const confirmed = await this.service.alert.show({
            title: '제거 확인',
            message: `[${project.title}] 프로젝트를 점검 작업 목록에서 제거하시겠습니까?`,
            status: 'warning',
            action: '제거',
            actionBtn: 'danger',
            cancel: '취소'
        });
        if (!confirmed) return;

        const { code } = await wiz.call('unselect', { project_id: project.id });
        if (code === 200) {
            this.onRemoved.emit(this.selectedProjects.filter((p: any) => p.id !== project.id));
        }
    }

    public goTo(project: any) {
        this.onGoTo.emit(project);
    }
}

export default ComponentMainProjectsComponent;